export default __webpack_public_path__ + "static/cms-8b2c551d15ad50445904c39a3f5d1c6d.png";